module.exports = __webpack_public_path__ + "img/haidi_TC.50712c50.jpg";